<se-fe-page
  [seFeDataLoaded]="!loadingItem"
  [seFeDataBackLink]="'../..'"
  [seFeDataBackText]="'LIST_VIEW.title' | translate"
  class="item-detail__page">
  <se-fe-header seFePageHeader [seFeDataTitle]="'DETAIL_VIEW.title' | translate" seFeDataSize="750">
    @if (item && !item.disabled) {
      <se-fe-button
        seFeHeaderActions
        class="item-detail__archive-button"
        data-dd-action-name="Archive Sale Item"
        seFeDataEmphasis="medium"
        [seFeDataIsDisabled]="archivingItem"
        (click)="confirmArchive($event)">
        <se-fe-icon seFeIconBefore seFeDataName="archive" seFeDataSize="700" [seFeDataMargin]="false"></se-fe-icon>
        {{ 'LIST_VIEW.archive' | translate }}
      </se-fe-button>
    }
  </se-fe-header>

  <div seFePageContent>
    @if (item) {
      <se-fe-grid seFeGridOpts>
        <se-fe-grid-cell seFeGridOpts="1/1">
          <se-fe-card class="item-detail__details-card">
            <se-fe-card-header
              class="item-detail__details-card-header"
              [seFeDataTitle]="item.name"
              [seFeDataSubtitle]="descriptionTitle">
              <div seFeCardHeaderActions [hidden]="hideEditAction()">
                @if (!item.catalog_id) {
                  <se-fe-icon-button (click)="toggleItemModal()">
                    <se-fe-icon seFeDataName="pencil_fill" seFeDataSize="700" [seFeDataAriaLabel]="'Edit'"></se-fe-icon>
                  </se-fe-icon-button>
                }
              </div>
            </se-fe-card-header>

            <se-fe-card-content>
              @if (item.variations.length <= 1) {
                <se-fe-grid seFeGridOpts="loose">
                  <se-fe-grid-cell seFeGridOpts="1/2@desktop 1/2@tablet 1/1@mobile">
                    <span class="item-detail__field-label" [translate]="'DETAIL_VIEW.type'"></span>
                    <div class="item-detail__field-value">{{ zeroRateType() }}</div>
                  </se-fe-grid-cell>

                  <se-fe-grid-cell seFeGridOpts="1/2@desktop 1/2@tablet 1/1@mobile">
                    <span class="item-detail__field-label" [translate]="'DETAIL_VIEW.sku'"></span>
                    <div class="item-detail__field-value">{{ defaultVariation.sku || '--' }}</div>
                  </se-fe-grid-cell>

                  <se-fe-grid-cell seFeGridOpts="1/2@desktop 1/2@tablet 1/1@mobile">
                    <span class="item-detail__field-label" [translate]="'DETAIL_VIEW.price'"></span>
                    <div class="item-detail__field-value">
                      {{ defaultVariation.price | currency: defaultVariation.currency }}
                    </div>
                    @if (showUpfrontAmountText) {
                      <div
                        class="item-detail__price-note pl-help-text--below"
                        [ngClass]="{ 'line-break': showTaxCode && !!defaultVariation.tax_code }"
                      [innerHtml]="upfrontAmountSettingText"></div>
                    }
                  </se-fe-grid-cell>

                  <se-fe-grid-cell seFeGridOpts="1/2@desktop 1/2@tablet 1/1@mobile">
                    <span class="item-detail__field-label" [translate]="'DETAIL_VIEW.upfront_amount'"></span>
                    <div class="item-detail__field-value">
                      {{ (defaultVariation.upfront_amount | currency: defaultVariation.currency) || '--' }}
                    </div>
                  </se-fe-grid-cell>

                  @for (priceSchedule of priceSchedules; track priceSchedule) {
                    <se-fe-grid-cell seFeGridOpts="1/2@desktop 1/2@tablet 1/1@mobile">
                      <span class="item-detail__field-label overflow-ellipsis">{{ priceSchedule.pricing_name }}</span>
                      <div class="item-detail__field-value">{{ priceSchedule.price_formatted || '--' }}</div>
                    </se-fe-grid-cell>
                    <se-fe-grid-cell seFeGridOpts="1/2@desktop 1/2@tablet 1/1@mobile">
                      <span class="item-detail__field-label overflow-ellipsis">
                        {{ priceSchedule.pricing_name }} Dates
                      </span>
                      <div class="item-detail__field-value">
                        {{ priceSchedule.start_date | date: 'mediumDate' }} -
                        {{ priceSchedule.end_date | date: 'mediumDate' }}
                      </div>
                    </se-fe-grid-cell>
                  }

                  @if (showTaxCode && !!defaultVariation.tax_code) {
                    <se-fe-grid-cell seFeGridOpts="1/3@desktop 1/2@tablet 1/1@mobile">
                      <span class="item-detail__field-label" [translate]="'DETAIL_VIEW.tax_code'"></span>
                      <div class="item-detail__field-value">{{ defaultVariation.tax_code }}</div>
                    </se-fe-grid-cell>
                  }
                </se-fe-grid>
              }

              @if (item.variations.length >= 2) {
                <se-fe-table-wrapper>
                  <table seFeTable [dataSource]="item.variations" [seFeDataFixedLayout]="false">
                    <ng-container seFeColumnDef="variation">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.variation' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let variation">
                        <a seFeLink [routerLink]="['../variation', variation.id, 'detail']">
                          {{ variation.name }}
                        </a>
                      </td>
                    </ng-container>

                    <ng-container seFeColumnDef="price">
                      <th seFeHeaderCell class="item-detail__cell--right" *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.price' | translate }}
                      </th>
                      <td seFeCell class="item-detail__cell--right" *seFeCellDef="let variation">
                        {{ variation.price | currency: variation.currency }}
                      </td>
                    </ng-container>

                    <ng-container seFeColumnDef="sku">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.sku' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let variation">
                        {{ variation.sku || '--' }}
                      </td>
                    </ng-container>

                    <ng-container seFeColumnDef="sold">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.sold' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let variation">
                        {{ variationStats[variation.id]?.sold_count ?? 0 }}
                      </td>
                    </ng-container>

                    <tr seFeHeaderRow *seFeHeaderRowDef="variationColumns; sticky: false"></tr>
                    <tr seFeRow *seFeRowDef="let row; columns: variationColumns"></tr>
                  </table>
                </se-fe-table-wrapper>
              }
            </se-fe-card-content>
          </se-fe-card>
        </se-fe-grid-cell>

        <se-fe-grid-cell seFeGridOpts="1/1">
          <se-fe-card class="item-detail__sales-card">
            <se-fe-card-header class="item-detail__sales-card-header" [seFeDataTitle]="'DETAIL_VIEW.sales' | translate">
              <a
                seFeCardHeaderActions
                seFeLink="low"
                class="item-detail__sales-report-link"
                [href]="getFinancialReportURL()"
                target="_top">
                {{ 'DETAIL_VIEW.view_report' | translate }}
              </a>
            </se-fe-card-header>

            <se-fe-card-content>
              @if (loadingSaleItems || showOverlay) {
                <se-fe-spinner
                  class="item-detail__loading"
                  [seFeDataSize]="900"
                [seFeDataCenter]="true"></se-fe-spinner>
              } @else if (!saleItems.length) {
                <se-fe-empty-state [seFeDataTitle]="'DETAIL_VIEW.nothing_to_report' | translate" [seFeDataSize]="500">
                  {{ 'DETAIL_VIEW.not_sold' | translate }}
                </se-fe-empty-state>
              } @else {
                <se-fe-table-wrapper>
                  <table seFeTable [dataSource]="saleItems" [seFeDataFixedLayout]="false">
                    <ng-container seFeColumnDef="created_at">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.date' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let saleItem">{{ saleItem.sale.created_at | date }}</td>
                    </ng-container>

                    <ng-container seFeColumnDef="type">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.type' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let saleItem">{{ saleItem.sale.type }}</td>
                    </ng-container>

                    <ng-container seFeColumnDef="sale">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.sale' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let saleItem">
                        @if (saleItem.sale.sale_number) {
                          <app-external-link
                            [url]="externalLinkService.getSaleUrl(saleItem.sale.sale_number, saleItem.sale.type)">
                            {{ saleItem.sale.sale_number }}
                          </app-external-link>
                        }
                      </td>
                    </ng-container>

                    <ng-container seFeColumnDef="member">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.member' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let saleItem">
                        @if (saleItem.profileUrl) {
                          <a seFeLink target="_top" [href]="saleItem.profileUrl">
                            {{ saleItem.metadata?.for?.title || saleItem.sale.user_full_name }}
                          </a>
                        } @else if (saleItem.sale.persona_id || saleItem.sale.user_full_name) {
                          <span>{{ saleItem.sale.user_full_name }}</span>
                        } @else if (!saleItem.sale.user_full_name && !saleItem.sale.persona_id) {
                          <span [translate]="'DETAIL_VIEW.anonymous_user'"></span>
                        }
                      </td>
                    </ng-container>

                    <ng-container seFeColumnDef="price">
                      <th seFeHeaderCell class="item-detail__cell--right" *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.price' | translate }}
                      </th>
                      <td seFeCell class="item-detail__cell--right" *seFeCellDef="let saleItem">
                        {{ saleItem.price | currency: saleItem.currency }}
                      </td>
                    </ng-container>

                    <ng-container seFeColumnDef="quantity">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.quantity' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let saleItem">{{ saleItem.quantity }}</td>
                    </ng-container>

                    <ng-container seFeColumnDef="item_total">
                      <th seFeHeaderCell class="item-detail__cell--right" *seFeHeaderCellDef>
                        {{ 'DETAIL_VIEW.item_total' | translate }}
                      </th>
                      <td seFeCell class="item-detail__cell--right" *seFeCellDef="let saleItem">
                        {{ saleItem.amount | currency: saleItem.currency }}
                      </td>
                    </ng-container>

                    <tr seFeHeaderRow *seFeHeaderRowDef="saleColumns; sticky: false"></tr>
                    <tr seFeRow *seFeRowDef="let row; columns: saleColumns"></tr>
                  </table>
                </se-fe-table-wrapper>

                <se-fe-pagination
                  [seFeDataPaginationOptions]="salesPaginationOptions"
                (seFePaginationChange)="handleSalesPagination($event)"></se-fe-pagination>
              }
            </se-fe-card-content>
          </se-fe-card>
        </se-fe-grid-cell>
      </se-fe-grid>
    }
  </div>
</se-fe-page>

@if (showItemModal && item) {
  <div class="sale-item-element-modal">
    <sale-item-element
      [organizationId]="currentOrgId"
      [originalItem]="item"
      [showInfoAlert]="hasSaleItems"
      [showSaleItemType]="item.variations[0].zero_rate_type !== null ? 'true' : 'false'"
      (closeSaleItemModal)="toggleItemModal()"
    (success)="onSuccess($event.detail)"></sale-item-element>
  </div>
}
